var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('tabela-blocos-rodape')],1),_c('div',{staticClass:"col-lg-6"},[_c('tabela-sociais-rodape')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }